import axios from "axios";

export const getAllAnggaranPengeluaran = async () => {
  return await axios.get(`${window._HOST}admin/anggaranPengeluaran/`, {
    withCredentials: true,
  });
};

export const getAllDetailAnggaranPengeluaran = async () => {
  return await axios.get(`${window._HOST}admin/anggaranPengeluaran/detail`, {
    withCredentials: true,
  });
};

export const getAllDataTableAnggaranPengeluaran = async (
  searchText = null,
  offset = 0,
  limit = 0,
  $sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/anggaranPengeluaran/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${$sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/anggaranPengeluaran/dataTable?offset=${offset}&limit=${limit}&sorting-col=${$sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getDropdownAnggaranPengeluaran = async () => {
  return await axios.get(`${window._HOST}/admin/anggaranPengeluaran/dropdown`, {
    withCredentials: true,
  });
};

export const getDropdownTahunAnggaranPengeluaran = async () => {
  return await axios.get(
    `${window._HOST}admin/anggaranPengeluaran/tahunAnggaran`,
    { withCredentials: true }
  );
};

export const getFilteredAnggaranPengeluaran = async (condition) => {
  return await axios.post(
    `${window._HOST}admin/anggaranPengeluaran/filteredData`,
    condition,
    { withCredentials: true }
  );
};

export const insertAnggaranPengeluaran = async (formData) => {
  return await axios.post(
    `${window._HOST}admin/anggaranPengeluaran/`,
    formData,
    { withCredentials: true }
  );
};

export const updataAnggaranPengeluaran = async (formData, id) => {
  return await axios.put(
    `${window._HOST}admin/anggaranPengeluaran/${id}`,
    formData,
    { withCredentials: true }
  );
};

export const deleteAnggaranPengeluaran = async (id) => {
  return await axios.delete(`${window._HOST}admin/anggaranPengeluaran/${id}`, {
    withCredentials: true,
  });
};
